import { useEffect, useMemo, useState } from 'react'
import * as Yup from 'yup'

import { UsersSearchList as View } from 'ui-components'
import { getUserByEmail } from '~map-preview/api/getUserByEmail'
import { useInviteUserToMapByEmail } from '~map-preview/hooks/useInviteUserToMapByEmail'
import { useInput } from '~map-preview/states/mapShare'
import { User } from '~map-preview/types/__generated/gql/graphql'

export const UsersSearchList = () => {
  const input = useInput()
  const { results, execSearch } = useGetUserByEmail()
  const { invite } = useInviteUserToMapByEmail()
  const isInputValid = useMemo(
    () => Yup.string().email().isValidSync(input),
    [input]
  )

  useEffect(() => {
    if (isInputValid && input) execSearch(input)
  }, [isInputValid, input])

  const handleAddEmailClick = async (email) => invite(email)

  if (!input) return null

  return (
    <View
      input={input}
      isInputValid={isInputValid}
      user={results}
      onAddEmailClick={handleAddEmailClick}
    />
  )
}

const useGetUserByEmail = () => {
  const [results, setResults] = useState<User>()
  const [isLoading, setLoading] = useState(false)

  const execSearch = async (email: string) => {
    try {
      setLoading(true)
      const data = await getUserByEmail({ email })
      setResults(data as User)
      setLoading(false)
    } catch (e) {
      setLoading(false)
    }
  }

  return { results, isLoading, execSearch }
}
